import logo from '../../assets/img/logo.png';

import LoginFooter from '../../Component/Footer';
import { useState,useEffect} from 'react';
const SignInNew = () => {
    let emailData = "";
    const [passwordActive, setPassword] = useState(true); 
    const [verifyCodeActive, setVerifyCode] = useState(false); 
    const [emailError, setEmailError] = useState(false); 
    const [passlError, setpassError] = useState(false); 
    const signupFromSubmit = (event:any) => {
        event.preventDefault();
        emailData = event.target.email ? event.target.email.value : '';
        const passData = event.target.password ? event.target.password.value : '';
          
        setEmailError(false);
        setpassError(false);

        if (emailData === "") {
            setEmailError(true);
        }
        if (passData === "") {
            setpassError(true);

        }
    };
    
    const SignInCode = () => {
        setPassword(!passwordActive);
        setVerifyCode(!verifyCodeActive);
        
    }
   

    return (<>
        <div className="loginrgstr-page loginPage">
            <div className="login_main">
                <div className='login-header'>
                        <div className='container'>
                        <div className='login-main'>
                            <div className="login-logo text-center">
                                <a href="/"> <img src={logo} alt="" /></a>
                            </div>
                            <div className='loginheader-right'>
                                {window.location.pathname === '/signup-new' ? (
                                    <a className='btn login-btn' href='/signin-new'>Sign in</a>
                                ) : (
                                    <a className='btn login-btn' href='/signup-new'>Sign up</a>
                                )}
                            </div>
                            </div>
                        </div>
                </div>
                <section className='loginrgstrform-section'>
                <div className='loginrgstr-maincover'>
                <div className='container'>
                <div className='loginrgstr-main'>
                <form onSubmit={signupFromSubmit}>
                <div className='loginscreen-area'>
                                <h1>Sign In</h1>
                                <div className="form-grid">
                                    <div className="form-group">
                                        <input type="email" placeholder="Email address" name="email" className="form-control" />
                                        {emailError && <p className='text-danger text-left'>Please fill in a valid email address</p>}
                                        {verifyCodeActive &&<p className='msgrated-text'>Message and data rates may apply</p>}
                                    </div>
                                    {passwordActive ? ( 
                                     <>
                                    <div className="form-group">
                                        <input type="password" placeholder="Password" name="password" className="form-control" />
                                        {passlError && <p className='text-danger text-left'>Please fill in a valid Password</p>}
                                    </div>
                                    </>
                                      ) : null}
                                    <div className="form-group">
                                    <button type="submit" className="btn w-100 text-center">
                                            <span>Sign In</span>
                                        </button>
                                    </div>
                                    <div className="form-group">
                                        <p className='text-white text-center'>OR</p>
                                    </div>
                                    <div className="form-group">
                                    <span onClick={SignInCode} className="btn w-100 text-center btn-signincode">
                                            <span>Use a sign-in code</span>
                                        </span>
                                    </div>
                                    {/* <div className="form-group">
                                    <div className="forgotpassword-text">
                                        <a className="linkforgot-password" href="/loginHelp">Forgot your password?</a>
                                    </div>
                                    </div> */}
                                    <div className="form-group">
                                    <div className="form-group">
                                        <div className="custom-control custom-checkbox">
                                        <input className="custom-control-input" type="checkbox" id="Rememberme"/>
                                        <label className="custom-control-label text-white" htmlFor="Rememberme">
                                            Remember me
                                        </label>
                                        </div>
                                    </div>
                                    </div>
                                    <div className="form-group">
                                    <p className='signup-text'><small>New to Darkroom?</small> <a href='/signup-new'> Sign up now.</a></p>
                                    </div>
                                </div>
                                <div className='recaptcha-text'>
                                    <p>This page is protected by Google reCAPTCHA to ensure<br></br> you're not a bot.</p>
                                    <p><a href='#'>Learn more</a></p>
                                </div>
                                
                                </div>
                            </form>
                    </div>
                    </div>
                </div>
                </section>
                <LoginFooter />
            </div>
        </div>
    </>)
}

export default SignInNew;